import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { t } from 'translates';
import CartFooterInfo from "./cartFooterInfo";
import PromoCode from "../../checkout/components/PromoCode";
import ContentMessage from "../../../common/components/contentMessage";
import langPrefix from 'common/helpers/langPrefix';

export default class CartFooter extends Component {
  static propTypes = {
    symbol: PropTypes.string.isRequired,
    tax: PropTypes.number.isRequired,
    subtotal: PropTypes.number.isRequired,
    separator: PropTypes.string.isRequired,
    payment_methods: PropTypes.shape({
      base_path: PropTypes.string,
      types: PropTypes.array,
    }),
    code: PropTypes.string.isRequired,
    addCode: PropTypes.func.isRequired,
    discount: PropTypes.object.isRequired,
    deleteCode: PropTypes.func.isRequired,
    onSubmitHandler: PropTypes.func.isRequired,
    submitSpinner: PropTypes.bool.isRequired,
  };

  constructor(props) {
    super(props);

    this.onSubmit = this.onSubmit.bind(this);
    this.onDeleteCode = this.onDeleteCode.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.code.length && !this.props.code.length) {
      const promoField = document.querySelector('.cart-info__promo-code input');
      if (promoField) { promoField.value = ''; }
    }
  }

  onSubmit(form) {
    this.props.addCode(form.code);
  }

  onDeleteCode(event) {
    event.preventDefault();

    this.setState({ code: '' });
    this.props.deleteCode();
  }

  render() {
    const {
      payment_methods,
      tax,
      subtotal,
      code,
      discount,
      onSubmitHandler,
      reservationErrors,
      currency_symbol,
      currency_separator,
      currency_decimal_separator,
      currency_position
    } = this.props;

    const {
      message: errorMessage,
    } = reservationErrors;
    return (
      <div className="cart-new-footer">
        <div className="cart-new-footer__title">
          {t('Order summary', DT_CART)}
        </div>

        <CartFooterInfo
          currency_symbol={currency_symbol}
          currency_separator={currency_separator}
          currency_decimal_separator={currency_decimal_separator}
          currency_position={currency_position}
          tax={tax}
          subtotal={subtotal}
          code={code}
          discount={discount}
          onDeleteCode={this.onDeleteCode}
        />

        {!discount.success && (
          <PromoCode
            setPromoCode={this.onSubmit}
            discount={{
              ...discount,
              code,
            }}
          />
        )}

        <div className="line-sep"></div>
        <div className="cart-new-proceed">
          <button
            className="button button-primary button-block button-lg"
            onClick={onSubmitHandler}
            disabled={!Object.keys(this.props.cart.purchases).length || this.props.cart.hasExpired || (this.props.cart.staffUser && (this.props.cart.quota && this.props.cart.quota.errors.length > 0))}
          >
            {t('Book now', DT_CART)}
          </button>
          {errorMessage && (
            <ContentMessage
              message={errorMessage}
            />
          )}

          {this.props.cart.quota && this.props.cart.quota.errors ? this.props.cart.quota.errors.map(quotaItem => (
            <ContentMessage
              message={quotaItem}
            />
          )) : null}

         <div>
           <a href={`/${langPrefix}`} className="button button-info button-block">
             {t('CONTINUE BOOKING', DT_CART)}
           </a>
         </div>
        </div>
        <div className="line-sep line-sep--gray"></div>
        <div className="cart-new-info__payment-methods">
          <div className="cart-new-info__title cart-new-info__title--payment-methods">{t('We accept', DT_CART)}</div>
          <div className="payment-methods__images">
            {payment_methods && payment_methods.types ? payment_methods.types.map(paymentMethod => (
              <div key={`payment_methods_${paymentMethod}`} className="cart-info__payment-method_icon">
                {payment_methods.base_path && paymentMethod && (
                  <img src={`${payment_methods.base_path}${paymentMethod}.svg`} alt="icon" />
                )}
              </div>
            )) : null}
          </div>
        </div>
      </div>
    );
  }
}
